import React from "react";
import EntityTable from "../EntityTable";
import {
  anchorConnectionColumnId,
  renderRowUpdateAction,
} from "../../common/TableUtils";
import { ConnectionFormDataController } from "../../controllers/formController";
import useReferenceVersionQuery from "../../hooks/query/connections/useReferenceVersionQuery";
import { Version } from "../../types/version";
import { Person } from "../../types/person";
import { ReferenceVersionConnection } from "../../types/referenceVersion";
import ReferenceVersionDialog from "../modals/ReferenceVersion/ReferenceVersionDialog";
import {
  referenceVersionColumns,
  referenceVersionFilterSpec,
} from "../../common/entities/ReferenceVersionColumns";
import useServerFilters from "../../hooks/useServerFilters";

interface ReferenceVersionTableProps {
  controller: ConnectionFormDataController<
    ReferenceVersionConnection,
    Version,
    Person | Version
  >;
  systemLanguageType: Version["system_language_type"];
}

const ReferenceVersionTable: React.FC<ReferenceVersionTableProps> = ({
  controller,
  systemLanguageType,
}) => {
  const {
    serverFilters,
    entityTableFilterProps,
    pagination,
    setPagination,
  } = useServerFilters<ReferenceVersionConnection>({}, referenceVersionFilterSpec);
  const { useFetchConnectedEdges } = useReferenceVersionQuery();
  const { anchorEntity, direction, openEditDialog } = controller;
  const { data, isLoading, errorMessage } = useFetchConnectedEdges(
    anchorEntity._id,
    direction,
    {
      bodyParams: serverFilters,
      externalPagination: pagination,
      externalSetPagination: setPagination,
    }
  );

  const renderActions = renderRowUpdateAction<ReferenceVersionConnection>((row) =>
    openEditDialog(row._key)
  );

  return (
    <>
      <EntityTable
        loading={isLoading}
        error={errorMessage}
        columns={referenceVersionColumns}
        hiddenColumnIds={[anchorConnectionColumnId(direction)]}
        renderRowActions={renderActions}
        enableRowActions
        data={data?.data || []}
        pagination={pagination}
        manualPagination
        onPaginationChange={setPagination}
        totalRowCount={data?.total || 0}
        manualFiltering
        {...entityTableFilterProps}
      />
      <ReferenceVersionDialog
        controller={controller}
        systemLanguageType={systemLanguageType}
      />
    </>
  );
};

export default ReferenceVersionTable;
